var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "aframe-container" },
    [
      !_vm.showApp
        ? _c("div", { staticClass: "aframe-loading-screen" }, [_vm._m(0)])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "a-scene",
        {
          ref: "scene",
          attrs: {
            embedded: "",
            "loading-screen": "dotsColor: #0CC0CC; backgroundColor: white",
            "vr-mode-ui": "enterVRButton: #myEnterVRButton",
          },
        },
        [
          _c(
            "a-assets",
            { attrs: { timeout: "10000" } },
            [
              _vm._l(_vm.videos, function (video) {
                return _c("video", {
                  attrs: {
                    crossOrigin: "anonymous",
                    preload: "auto",
                    id: "video-" + video.id,
                    src: video.url,
                  },
                })
              }),
              _vm._v(" "),
              _c("audio", {
                attrs: { id: "audio-bop", src: "/aframe-assets/audio/bop.mp3" },
              }),
              _vm._v(" "),
              _c("img", {
                attrs: {
                  id: "icon-sync",
                  src: "/aframe-assets/icons/sync.png",
                },
              }),
              _vm._v(" "),
              _c("img", {
                attrs: {
                  id: "icon-cancel",
                  src: "/aframe-assets/icons/cancel-padded.png",
                },
              }),
            ],
            2
          ),
          _vm._v(" "),
          _vm.currentPage
            ? _c("a-entity", {
                attrs: { cubemap: _vm.cubemap },
                on: { cubemapLoaded: _vm.onSkyLoaded },
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "a-entity",
            {
              attrs: {
                position: "0 0 0",
                "rotate-towards": _vm.currentPageRotation,
              },
            },
            [
              _c("home-panel", {
                attrs: {
                  id: "homePanel",
                  position: "0.4 1 -0.4",
                  rotation: "-40 -75 0",
                  sites: _vm.sites,
                  pages: _vm.pages,
                  "current-page": _vm.currentPage,
                  title: _vm.currentSite ? _vm.currentSite.name : "",
                  "vr-mode": _vm.vrMode,
                  "is-vr-mode": _vm.isVrMode,
                  "home-panel-position": "",
                },
                on: {
                  "select-page": function ($event) {
                    return _vm.setPage($event)
                  },
                  "select-site": function ($event) {
                    return _vm.setCurrentSite($event)
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "a-entity",
                { attrs: { id: "rig" } },
                [
                  _c(
                    "a-entity",
                    {
                      attrs: {
                        id: "camera",
                        camera: "",
                        "wasd-controls": "acceleration: 20",
                        position: "0 1.6 0",
                        "look-controls": "reverseMouseDrag: true",
                      },
                    },
                    [
                      _c("a-entity", {
                        attrs: {
                          raycaster: "objects: .clickable",
                          cursor: "rayOrigin: mouse",
                        },
                      }),
                      _vm._v(" "),
                      _vm.vrMode === "phone"
                        ? _c("a-entity", {
                            attrs: {
                              cursor: "fuse: true;",
                              geometry:
                                "primitive:ring;radiusInner:0.005;radiusOuter:0.008",
                              animation__click:
                                "property: scale; startEvents: click; easing: easeInCubic; dur: 150; from: 0.1 0.1 0.1; to: 1 1 1",
                              animation__fusing:
                                "property: scale; startEvents: fusing; easing: easeInCubic; dur: 1500; from: 1 1 1; to: 0.1 0.1 0.1",
                              animation__mouseleave:
                                "property: scale; startEvents: mouseleave; easing: easeInCubic; dur: 500; to: 1 1 1",
                              material: "color: red; shader: flat",
                              position: "0 0 -0.5",
                              raycaster: "objects: .clickable;",
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("a-entity", {
                    attrs: {
                      "oculus-touch-controls": "hand: right",
                      "laser-controls": "",
                      raycaster:
                        "objects: .clickable; lineColor: white; lineOpacity: 1",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("link-spots", {
            attrs: {
              "advanced-visible": "!skyIsLoading",
              page: _vm.currentPage,
              pages: _vm.pages,
            },
          }),
          _vm._v(" "),
          _c("info-spots", {
            attrs: {
              "advanced-visible": "!skyIsLoading",
              page: _vm.currentPage,
              pages: _vm.pages,
            },
          }),
          _vm._v(" "),
          _c("navigation-panel", {
            attrs: {
              id: "navigationPanel",
              position: "0 1.6 -1.5",
              rotation: "0 0 0",
              "advanced-visible": "false",
              modal: "distance: 1.5",
              pages: _vm.pages,
              "current-page": _vm.currentPage,
            },
            on: {
              "select-page": function ($event) {
                return _vm.setPage2($event)
              },
            },
          }),
          _vm._v(" "),
          _c("a-entity", {
            attrs: {
              id: "line",
              line: "start: 0 0 0; end: 2 2 -5; color: #4cb7ed",
              "advanced-visible": "false",
            },
          }),
          _vm._v(" "),
          _c("a-yoga-layout", {
            attrs: {
              id: "tooltip",
              "width-auto": "1",
              "height-auto": "1",
              padding: "0.05",
              "flex-wrap": "wrap",
              "flex-direction": "column",
              "align-items": "center",
              "justify-content": "center",
              geometry: "primitive: rounded-plane;",
              material: "color: #001034;",
              "push-mesh-backwards": "",
              "advanced-visible": "false",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("img", { attrs: { src: "/img/loader.png" } }),
      _c("br"),
      _vm._v("\n          LOADING\n        "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }